import {Col, Form, FormInstance, Radio, Row, Space, Tag} from "antd";
import {ComponentProps, useEffect, useState} from "react";
import {useRequest} from "ahooks";
import * as api from "../../apis/productCategory";
import styles from "./index.module.css";



interface CategoryMultipleLevelSelectProps extends ComponentProps<any> {
    value?: any;
    level?: number;
    onChange?:Function;
};

function CategoryMultipleLevelSelect(props: CategoryMultipleLevelSelectProps) {
    const {level = 1, value = null, onChange, ...otherProps} = props;
    const [values, setValues] = useState(new Array(level).fill(null));
    const [categories, setCategories] = useState<Array<any>>([]);
    const [rows, setRows] = useState<Array<any>>([]);
    const {loading: loadingGetCategory, run: getCategories} = useRequest(api.getCategoriesDict, {
        manual: false,
        onSuccess(res) {
            const result = res.data.data || [];
            setCategories(result);
        }
    });
    useEffect(() => {
        // console.log('value is '+ value);
        if (!value) {
            setValues(new Array(level).fill(null));
        } else {
            let options: Array<any> = categories;
            while (true) {
                const category = options.find(c => c.id == value);
                if (!!category) {
                    const ids = (category.parents || '').replace('//', '').split('/').filter((c:any)=>!!c)
                    const newValues = [...values];
                    newValues[ids.length] = value;
                    for (let j = ids.length+1; j < level; j++) {
                        newValues[j]=null;
                    }
                    setValues([...newValues]);
                    return;
                } else {
                    options = options.filter(c => !!c.id).map(c => c?.children || []).flat();
                    if (!options.find(o => !!o.id)) {
                        setValues(new Array(level).fill(null));
                        return;
                    }
                }
            }
        }
    }, [value, categories]);

    useEffect(() => {
        // console.log('values is ' + values);
        const rowElements = [];
        const labels = ['产品线'];
        let options = categories;
        for (let i = 0; i < level; i++) {
            const tags = options.map(o=>{
                return <Radio className={styles.Radio} key={'item-'+o.id} value={o.id} onClick={()=>handleChange(i,o.id)}>{o.name}</Radio>
            });
            const opt = options.find(o=>o.id===values[i]);
            if(!!opt){
                options = opt.children||[];
                labels[i+1] = opt.name;
            }else{
                labels[i+1] = `商品${i+2}级分类`;
                options = options.map(o=>o.children||[]).flat();
            }
            const nullTag = <Radio className={styles.Radio} key={'item-null'} value={null} onClick={()=>handleChange(i,null)}>全部</Radio>;
            rowElements.push(<Row key={'row-'+i}>
                <Col span={2} className={styles.Label}>
                    <label>{labels[i]}:</label>
                </Col>
                <Col span={22}>
                    <Radio.Group className={styles.Group} name={'group-'+i} value={values[i]}>{nullTag}{tags}</Radio.Group>
                </Col>
            </Row>);
        }
        setRows(rowElements);
    }, [values]);

    const handleChange = (i: number, v?: number | null) => {
        const newValues = [...values];
        newValues[i] = v;
        for(let j=i+1;j<level;j++){
            newValues[j] = null;
        }
        const result = newValues.reverse().find(it=>!!it);
        onChange && onChange(result);
    }
    const fillNullCategory = (resources: Array<any>) => {
        const nullCategory: any = {id: null, name: '全部', children: []}
        const children = resources.map(i => {
            const itemChildren: Array<any> = Array.isArray(i.children) && i.children.length ? fillNullCategory(i.children) : [nullCategory];
            return {...i, children: itemChildren}
        }).flat();
        nullCategory.children = children;
        return [nullCategory, ...children];
    }
    return <div {...otherProps}>
        {rows}
    </div>
}

export default CategoryMultipleLevelSelect;